import { t } from "i18next";
import { toast } from "react-hot-toast";
import { Modal } from "ui";

import { useDeleteFaqItem } from "../../../apis";
import { DeleteFAQItemModalProps } from "./DeleteFAQItemModal.types";

import styles from "./DeleteFAQItemModal.module.scss";

const DeleteFAQItemModal = ({ isOpen, id, onClose }: DeleteFAQItemModalProps) => {
  const deleteFaqItem = useDeleteFaqItem({
    onSuccess: () => {
      onClose();
      toast.success(t("Question has been deleted successfully"));
    }
  });

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title="Delete Question"
      isLoading={deleteFaqItem.isLoading}
      okText="Delete"
      onOk={() => deleteFaqItem.mutate(id)}
      contentClassName={styles.modal}
      onClose={onClose}
    >
      <p className={styles.modal_text}>
        {t("Are you sure you want to delete this question?")}
      </p>
    </Modal>
  );
};

export default DeleteFAQItemModal;
